import * as api from "@/api/hitachi/rbi";
import * as inventory from "@/api/hitachi/inventory";
import { Dispatch } from "react";
import { Page } from "@/util";
import { RbiAction } from "./reducer";
import { useMutation, useQuery } from "react-query";
import { WelderRow, WeldListFilters } from "@/api/hitachi/rbi";
import { WelderState } from "./types";

export function useGetOperations(parentId?: string) {
  const id = parentId ?? "";
  return useQuery({
    enabled: Boolean(id),
    queryKey: ["rbi/welder/operations", { id }],
    queryFn: () => api.getWelderOperations(id),
    select: (data: string[]) => {
      return data.map((fullString) => ({
        withDescription: fullString,
        number: fullString.split(" ")[0],
      }));
    },
  });
}

export function useGetWeldList(filters: Partial<WeldListFilters>) {
  return useQuery({
    queryKey: ["rbi/welder/welds", filters],
    queryFn: () => api.getWelderWeldList(filters),
  });
}

export function useGetProcesses(state: WelderState, updateState: Dispatch<RbiAction>) {
  const weldIds = state.welds.map((x) => x.weldId);
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["rbi/welder/processes", { weldIds }],
    queryFn: () => api.getWelderRows(weldIds),
    onSuccess: (data) => {
      updateState({ type: "Processes", payload: data });
    },
  });
}

export function useSave() {
  return useMutation(async (args: { processes: WelderRow[]; redirect: boolean }) => {
    await api.saveWelderRows(args.processes);
    if (args.redirect) {
      Page.redirect("rbi/hitachi/welder");
    }
  });
}

export function useAssetNumbers(process: string) {
  return useQuery({
    queryKey: ["rbi/welder/assetNumber", { process }],
    queryFn: () => inventory.getAssetNumbers(process),
  });
}

export function useLotNumbers(process: string, classification: string) {
  return useQuery({
    queryKey: ["rbi/welder/lotnumbers", { process, classification }],
    queryFn: () => inventory.getLotNumbers(process, classification),
  });
}

export function useQualityPlanLocation(subProjectId?: string) {
  const unitId = subProjectId ?? "";
  return useQuery({
    enabled: Boolean(unitId),
    queryKey: ["rbi/hitachi/quality-plan/location", { unitId }],
    queryFn: () => api.getQualityPlanLocation(unitId),
  });
}
